export const DEA_ROUTE_NAME = 'deaLicenses';
export const CDS_ROUTE_NAME = 'cdsLicenses';
export const MEDICAL_LICENSE_ROUTE_NAME = 'medicalLicenses';
export const EDUCATION_ROUTE_NAME = 'education';
export const TRAINING_ROUTE_NAME = 'training';
